export default function User({ fill = "#004e99", className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.264"
      height="24.17"
      viewBox="0 0 17.264 24.17"
      className={className}
    >
      <g id="user" transform="translate(-6.75 -2.25)">
        <path
          id="Path_4"
          data-name="Path 4"
          d="M16.167,3.976a4.316,4.316,0,1,1-4.316,4.316,4.316,4.316,0,0,1,4.316-4.316m0-1.726A6.042,6.042,0,1,0,22.21,8.292,6.042,6.042,0,0,0,16.167,2.25Z"
          transform="translate(-0.785 0)"
          fill={fill}
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M24.014,30.608H22.288V26.292a4.316,4.316,0,0,0-4.316-4.316H12.792a4.316,4.316,0,0,0-4.316,4.316v4.316H6.75V26.292a6.042,6.042,0,0,1,6.042-6.042h5.179a6.042,6.042,0,0,1,6.042,6.042Z"
          transform="translate(0 -4.189)"
          fill={fill}
        />
      </g>
    </svg>
  );
}
